module.exports = __webpack_public_path__ + "static/img/logo_ty_icon.png";